import { combineReducers } from 'redux';

import pointOfInterests from './entities/pointOfInterests';
import projects from './entities/projects';
import facilities from './entities/facilities';

import design from './domain/design';
import map from './domain/map';
import analysis from './domain/analysis';
import compare from './domain/compare';
import user from './domain/user';

import newProjects from './newProjects/projects';

export default combineReducers({
  entities: combineReducers({
    pointOfInterests,
    projects,
    facilities,
  }),
  domain: combineReducers({
    design,
    map,
    compare,
    analysis,
    user,
  }),
  newProjects: newProjects
});



// WEBPACK FOOTER //
// ./src/reducers/index.js